import type { ReactNode } from "react";
import { BrandIcon, type BrandIconName } from "@/components/brand/icons";
import { cx } from "@/components/ui/cx";
import { authJourneyStyles as styles } from "./auth-journey";

export function OutcomeToken({
  icon,
  label,
}: {
  icon: BrandIconName;
  label: string;
}) {
  return (
    <div className={styles.token} role="img" aria-label={label}>
      <BrandIcon name={icon} size={27} />
    </div>
  );
}

export function OutcomePanel({
  icon,
  iconLabel,
  message,
  details,
  children,
  live = "polite",
  className,
}: {
  icon: BrandIconName;
  iconLabel: string;
  message: ReactNode;
  details?: ReactNode;
  children?: ReactNode;
  live?: "off" | "polite" | "assertive";
  className?: string;
}) {
  return (
    <section
      className={cx(styles.panel, className)}
      role={
        live === "assertive" ? "alert" : live === "polite" ? "status" : undefined
      }
      aria-live={live}
      aria-atomic={live === "assertive" ? true : undefined}
    >
      <OutcomeToken icon={icon} label={iconLabel} />
      <div className={styles.message}>{message}</div>
      {details ? <div className={styles.details}>{details}</div> : null}
      {children}
    </section>
  );
}
